export const ScoreTypeEnum = {
    numScore: 1,
    textScore: 2
}